var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.125C14.4219 3.125 16.375 5.11719 16.375 7.5C16.375 9.92188 14.4219 11.875 12 11.875C9.57812 11.875 7.625 9.92188 7.625 7.5C7.625 7.14844 7.70312 6.64062 7.82031 6.28906C8.05469 6.44531 8.5625 6.5625 8.875 6.5625C10.0469 6.5625 11.0625 5.58594 11.0625 4.375C11.0234 4.10156 10.9062 3.59375 10.75 3.32031C11.1016 3.24219 11.6484 3.16406 12 3.125ZM23.0938 6.95312C23.1719 7.10938 23.2109 7.34375 23.2109 7.5C23.2109 7.69531 23.1719 7.92969 23.0938 8.08594C20.9844 12.2266 16.7656 15 12 15C7.19531 15 2.97656 12.2266 0.867188 8.08594C0.789062 7.92969 0.75 7.69531 0.75 7.53906C0.75 7.34375 0.789062 7.10938 0.867188 6.95312C2.97656 2.8125 7.19531 0 12 0C16.7656 0 20.9844 2.8125 23.0938 6.95312ZM12 13.125C15.8281 13.125 19.3828 10.9766 21.2578 7.5C19.3828 4.02344 15.8281 1.875 12 1.875C8.13281 1.875 4.57812 4.02344 2.70312 7.5C4.57812 10.9766 8.13281 13.125 12 13.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.432f9015f86ed586a3739424955cf586.svg";
export { ForwardRef as ReactComponent };